<template>
    <v-container
        fluid
    >
        <v-row
            align="center"
            justify="center"
        >
            <img
                height="150"
                width="300"
                src="/soundanalytics.svg"
            >
        </v-row>
        <v-row
        no-gutters
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                sm="8"
                md="4"
            >
                <v-card
                    class="mx-auto my-12"
                    max-width="400"
                >
                    <v-card-title>
                        Recuperar contraseña
                    </v-card-title>
                    <v-card-text>
                        <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation
                        >
                            <v-text-field
                                label="usuario o correo electrónico"
                                name="Username"
                                type="text"
                                v-model="username"
                                :rules="userRules"
                                outlined
                                required
                                dense
                            ></v-text-field>
                        </v-form>
                        <div align="center" style="color:red">
                            {{errorRecover}}
                        </div>
                    </v-card-text>
                    <v-card-actions style="margin-top: -17px;">
                        <v-btn
                            width="95%"
                            color="success"
                            class="ma-2"
                            :disabled="!valid"
                            @click="validate"
                        >
                            Enviar
                        </v-btn>
                    </v-card-actions>
                    <v-card-text align="center">
                        ¿Aún no tienes cuenta? <a> Contactanos </a>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row
            align="end"
            justify="center"
        >
            <p class="font-weight-light">
                Copyright © {{currentYear}} — SoundAnalytics 
            </p>
        </v-row>
    </v-container>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'Login',

		data: () => ({
            valid: false,
            userRules: [
                v => !!v || 'Usuario o correo electrónico es requerido',
            ],
            username: ""
		}),
		
		methods: {
            validate () {
                const isValid = this.$refs.form.validate()

                if (!isValid)
                    return
                
                const payload = {
                    user: this.username
                }
                
                this.$store.dispatch('sendEmailRecover', payload)
            },
		},

		computed: {
            errorRecover () {
                return this.$store.getters.errorRecover
            },
            currentYear () {
                return moment().format("YYYY")
            }
		},

		watch : {

		},

		created () {
			moment.locale('es-us')
		}

	}
</script>